import styled from "styled-components";

const ImageA4Preview = styled.img`
  width: 172mm;
  height: 251mm;
`;

export default ImageA4Preview;
